import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

//Components
import Type from "./../Global/Typography.js";
import NanoFlex from "./../Global/NanoFlex";
import SocialIcons from "./../Nano/SocialIcons.js";
import Modal from "./../Global/Modal.js";
import WarningContent from "./../Micro/Warning/WarningContent.js";
import Checkbox from "./../Nano/Checkbox.js";
import Input from "./../Nano/Input.js";
import Button from "./../Nano/Buttons/Button.js";

//Images
import notch from "./../Global/Icons/nota-notch.svg";
import { ReactComponent as Warning } from "./../Global/Icons/warning.svg";
import { ReactComponent as Check } from "./../Global/Icons/check.svg";

const multiple = nota.global.multiple;

const StyledFormLogin = styled.div`
  width: 100%;
  height: auto;
  min-height: inherit;
  .formWrapper {
    position: relative;
  }
  .notchWrapper {
    position: absolute;
    height: auto;
    width: auto;
    z-index: 1;
  }
  .loginForm {
    max-width: 400px;
    .bckWrapper {
      padding: ${multiple * 2 + "px"}; /*16px*/
      background-color: ${nota.color.neutral.white};
      position: relative;
      .notchFormWrapper {
        display: none;
        position: absolute;
        right: 48px;
        top: -34px;
        img {
          transform: rotate(90deg) scale(0.8);
        }
      }

      @media only screen and (max-width: ${nota.global.breakpoints.verticalTablet + "px"}) {
        box-shadow: 0px 6.56334px 6.56334px rgba(0, 0, 0, 0.25);
        .notchFormWrapper {
          display: block;
          right: 22px;
          top: -39px;
          img {
            transform: rotate(90deg) scale(0.6);
          }
        }
      }
    }
    .form-wrapper {
      width: 350px;
      padding: ${multiple + "px"}; /*8px*/
    }
    .formRecover {
      .inputContainer {
        margin-top: 56px;
      }
    }
    .secondarySection {
      margin: 40px 0px;
      margin-bottom: ${multiple + "px"}; /*8px*/
    }
  }

  /* ALERT NOTIFICATION */
  .notificationsWrapper {
    min-height: 41px;
  }

  .alertNotificationWrapper {
    height: auto;
    width: 100%;

    .alertWrapper {
      padding: ${multiple + "px"};
      .iconWrapper {
        width: auto;
        margin: 0 ${multiple * 2 + "px"};
        svg {
          width: auto;
          height: 25px;
        }
      }
      .notificationWrapper {
        margin-left: ${multiple * 2 + "px"};
      }
    }
  }

  .errorNotification {
    background-color: ${nota.color.main.mTwo};
    .iconWrapper {
      svg {
        path {
          fill: ${nota.color.neutral.white};
        }
      }
    }
    .notificationWrapper {
      p {
        color: ${nota.color.neutral.white};
      }
    }
  }

  .sucessNotification {
    background-color: ${nota.color.neutral.lightGrey};
    margin: 61px 0;
    .alertWrapper {
      .iconWrapper {
        margin-top: 20px;
        svg {
          path {
            fill: ${nota.color.main.default};
          }
        }
      }
    }

    .notificationWrapper {
      margin: 20px 0;
      p {
        color: ${nota.color.main.default};
      }
    }
  }

  @media only screen and (max-width: ${nota.global.breakpoints.verticalTablet + "px"}) {
    .notchWrapper {
      display: none;
    }
  }
`;

const FormLogin = (props) => {
  return (
    <StyledFormLogin>
      <NanoFlex className="notchWrapper" justifyContent={"flex-start"} alignItems={"flex-start"} alignContent={"flex-start"}>
        <img src={notch} alt="nota notch" />
      </NanoFlex>
      <NanoFlex className="formWrapper" flexDirection={"column"}>
        <NanoFlex className="loginForm" flexDirection={"column"} flexWrap={"warp"}>
          <NanoFlex className="bckWrapper" flexDirection={"column"}>
            <div className="notchFormWrapper">
              <img src={notch} alt="nota notch" />
            </div>

            {!props.recoverPasswordVisible && (
              <form className="form-wrapper" onSubmit={props.loginSubmit}>
                <div>
                  <Type.h2>
                    Welcome to <b>NOTA</b>
                  </Type.h2>
                </div>
                <Input id={0} name="username" title="Username" placeholder="Username" defaultValue={props.username} error={props.error} onChangeAction={props.onChangeActionUsername} />
                <Input id={1} name="password" title="Password" placeholder="Password" defaultValue={props.password} eye={true} error={props.error} onChangeAction={props.onChangeActionPassword} />
                <Checkbox id={0} toggle={props.toggleCheckBox} label={"Stay signed in"} onChangeAction={props.onChangeActionRememberMe} />
                <NanoFlex margin="16px 0px" flexDirection="column">
                  <Button id={0} label={"login"} type={"submit"} disable={props.loginDisabled} />
                  <Button id={1} label={"Forgot password?"} type={"button"} simple clickAction={(id) => props.onChangeActionRecoverPasswordVisible(true)} />
                </NanoFlex>
              </form>
            )}

            {props.recoverPasswordVisible && (
              <form className="form-wrapper formRecover" onSubmit={props.recoverPasswordSubmit}>
                <div>
                  <Type.h2>
                    Recover <b>NOTA</b> Password
                  </Type.h2>
                  <Type.p>Reset your password by providing your email address</Type.p>
                </div>

                {!props.recoverPasswordStatus && <Input id={0} title="Email" placeholder="Email" defaultValue={props.recoverPasswordEmail} error={props.recoverPasswordEmailError} onChangeAction={props.onChangeActionRecoverPasswordEmail} />}

                <NanoFlex className="notificationsWrapper">
                  {/*ERROR NOTIFICATION*/}
                  {props.recoverPasswordStatus === false && (
                    <NanoFlex className="alertNotificationContainer">
                      <NanoFlex className="alertNotificationWrapper errorNotification">
                        <NanoFlex className="alertWrapper">
                          <NanoFlex className="iconWrapper">
                            <Warning />
                          </NanoFlex>
                          <NanoFlex className="notificationWrapper" justifyContent={"flex-start"} alignContent={"flex-start"}>
                            <Type.p>Email does not exist!</Type.p>
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                  )}

                  {/*SUCESS NOTIFICATION*/}
                  {props.recoverPasswordStatus === true && (
                    <NanoFlex className="alertNotificationContainer">
                      <NanoFlex className="alertNotificationWrapper sucessNotification">
                        <NanoFlex className="alertWrapper" flexDirection="column">
                          <NanoFlex className="iconWrapper">
                            <Check />
                          </NanoFlex>
                          <NanoFlex className="notificationWrapper" justifyContent={"center"} alignContent={"center"}>
                            <Type.p>Email sent successfully!</Type.p>
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                  )}
                </NanoFlex>

                <NanoFlex margin="16px 0px" flexDirection="column">
                  {!props.recoverPasswordStatus && <Button id={0} label={"Send"} type={"submit"} disable={props.recoverPasswordDisabled} />}
                  <Button id={1} label={"Return to Login?"} type={"button"} simple clickAction={(id) => props.onChangeActionRecoverPasswordVisible(false)} />
                </NanoFlex>
              </form>
            )}

            <NanoFlex className="secondarySection" flexDirection="column">
              <Type.h3>
                <b>ASK FOR FREE TRIAL</b>
              </Type.h3>
              <Type.p>
                Please contact <b>NOTA Team</b>
              </Type.p>
              <Link to="/freeTrial" target="_blank">
                <Button id={2} label={"free trial"} secondary />
              </Link>
            </NanoFlex>

            <SocialIcons />
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
      <Modal show={props.showModal} content={<WarningContent cancelAction={props.cancelActionModal} nextAction={props.nextActionModal} />} />{" "}
    </StyledFormLogin>
  );
};

// Set default props

export default FormLogin;

// --- // Documentation // --- //
/*
import FormLogin from './../Micro/FormLogin.js';

<FormLogin />
*/
